
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";
import CaseStudySection from "@/components/home/CaseStudySection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import GlobalFaqSection from "@/components/shared/GlobalFaqSection";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ServicosSection from "@/components/home/ServicosSection";
import { ServiceSelectionProvider } from "@/contexts/ServiceSelectionContext";
import ProductPlanSection from "@/components/product/ProductPlanSection";
import SEO from "@/components/SEO";
import useMetaTracking from "@/hooks/use-meta-tracking";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const Index = () => {
  const { trackViewContent } = useMetaTracking();

  // Track page view for analytics
  useEffect(() => {
    trackViewContent({
      content_name: "homepage",
      content_category: "landing_page"
    });
  }, [trackViewContent]);

  // Schema.org structured data for the homepage
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Dr.Cash - Soluções financeiras para clínicas de saúde",
    "description": "A Dr.Cash cuida da saúde financeira da sua clínica com boleto parcelado e antecipação de recebíveis. Aumente seu faturamento e melhore seu fluxo de caixa.",
    "publisher": {
      "@type": "Organization",
      "name": "Dr.Cash",
      "logo": {
        "@type": "ImageObject",
        "url": "https://drcash.com.br/wp-content/uploads/2024/01/site-fav-2-1.png"
      }
    },
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Boleto Parcelado",
          "url": "https://drcash.com.br/boleto-parcelado"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Antecipação de Recebíveis",
          "url": "https://drcash.com.br/antecipacao"
        }
      ]
    }
  };

  return (
    <>
      <SEO 
        title="Dr.Cash - Soluções financeiras para clínicas de saúde | Boleto Parcelado | Antecipação"
        description="A Dr.Cash cuida da saúde financeira da sua clínica com boleto parcelado e antecipação de recebíveis. Receba em 48h, parcele em até 24x e aumente seu faturamento."
        keywords="financiamento clínica médica, boleto parcelado saúde, antecipação recebíveis médicos, soluções financeiras clínicas, parcelamento procedimentos médicos"
        structuredData={homeStructuredData}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServicosSection />
        <AboutSection />
        <CaseStudySection />
        <TestimonialsSection />
        <ServiceSelectionProvider>
          <ProductPlanSection 
            title="Planos que cabem no seu bolso" 
            subtitle="Escolha o plano ideal para o seu negócio e comece a usar hoje mesmo"
          />
        </ServiceSelectionProvider>
        <GlobalFaqSection 
          maxItems={6}
          showFeaturedOnly={true}
          showCategories={false}
        />
        <div className="flex justify-center pb-16">
          <Link 
            to="/faq"
            className="btn-primary inline-flex items-center"
          >
            Ver todas as perguntas
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Index;
